import {BaseDataProviderAgent} from "./BaseDataProviderAgent";
import {ListOptions} from "../../../services/intf/ListOptions";
import {ListResult} from "../../../model/ListResult";
import {DataProvider} from "../../../services/intf/DataProvider";
import {BaseReadDataProvider} from "./BaseReadDataProvider";

export class BaseDataProvider<TItem, TListOptions extends ListOptions>
    extends BaseReadDataProvider<TItem, TListOptions> {

    constructor(baseUrl: string) {
        super(baseUrl);
    }

    delete = (id: string): Promise<void> =>
        BaseDataProviderAgent.send<TItem>(
            'delete',
            `${this.baseUrl}/${id}`).then();

    getInsertData = (data: TItem): any => data;
    getUpdateData = (id: string, data: TItem): any => data;

    insert = (data: TItem): Promise<TItem> =>
        BaseDataProviderAgent.send<TItem>(
            'post',
            `${this.baseUrl}`,
            this.getInsertData(data));

    update = (id: string, data: TItem): Promise<TItem> =>
        BaseDataProviderAgent.send<TItem>(
            'patch',
            `${this.baseUrl}/${id}`,
            this.getUpdateData(id, data));
}